import { cn } from '@repo/tailwind-config/tailwind.functions'
import { Option } from '@repo/toolkit/types'

import { typography } from './typography'

interface SwitchButtonsProps<T extends string> {
  items: Option<T>[]
  value: T
  onChange: (value: T) => void
}

const SwitchButtons = <T extends string>({ items, value, onChange }: SwitchButtonsProps<T>) => {
  return (
    <div className="w-fit flex border border-grey-light rounded overflow-hidden">
      {items.map((item) => (
        <button
          type="button"
          key={item.value}
          onClick={() => onChange(item.value)}
          style={typography['label-semibold']}
          className={cn('py-2 px-3', {
            'text-primary bg-primary-light': item.value === value,
            'text-grey-lighter': item.value !== value
          })}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}

export default SwitchButtons
